import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatHoldNotes } from "../hold-notes-formatter";

export const HoldNotesCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Hold notes", cell: (row) => formatHoldNotes(row.holds) };
